/**
 * Card Variant Picker - Updates variant selection and add-to-cart button state
 * when user selects a size/option on product cards (PLP).
 */
(function () {
  function initCardVariantPickers() {
    document.querySelectorAll('.card-variant-picker:not(.card-variant-picker--preview-only)').forEach((picker) => {
      if (picker.dataset.initialized) return;
      picker.dataset.initialized = 'true';

      const inputs = picker.querySelectorAll('.card-variant-picker__input');
      const variantInput = picker.querySelector('.card-variant-picker__variant-input');
      const submitButton = picker.querySelector('.card-variant-picker__submit');
      const submitText = picker.querySelector('.card-variant-picker__submit-text');

      if (!inputs.length || !variantInput) return;

      inputs.forEach((input) => {
        input.addEventListener('change', () => {
          variantInput.value = input.value;
          variantInput.disabled = false;
          if (submitButton) {
            const available = input.dataset.available === 'true';
            submitButton.disabled = !available;
            if (submitText) {
              const addText = picker.dataset.addText || 'Add to cart';
              const soldOutText = picker.dataset.soldOutText || 'Sold out';
              submitText.textContent = available ? addText : soldOutText;
            }
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardVariantPickers);
  } else {
    initCardVariantPickers();
  }

  // Re-init when sections are re-rendered (e.g. facet filters)
  document.addEventListener('shopify:section:load', initCardVariantPickers);
})();
